import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/successfulAddRoleDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddRole_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddRole_action_icon' />
        <Typography className='SuccessfulAddRole_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfullAddMetierDialog = ({ openSuccessfulAddMetier, setOpenSuccessfulAddMetier, setOpenAddMetier }) => {

    const { t } = useTranslation();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddMetier(false);
        setOpenAddMetier(true);
    }, [setOpenAddMetier, setOpenSuccessfulAddMetier]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddMetier(false);
    }, [setOpenSuccessfulAddMetier]);

    return (
        <Dialog open={openSuccessfulAddMetier} onClose={handleClose} classes={{ paper: 'SuccessfulAddRole_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddRole_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddRole_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddRole_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddRole_check_icon' />
                <Typography className='SuccessfulAddRole_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddRole_action_container'>
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={t('List des métiers')}
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text={t('addMetierDialogeTitle')}
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};